import { render, staticRenderFns } from "./DeviceBoxContainer.vue?vue&type=template&id=b3ab833a&scoped=true&"
import script from "./DeviceBoxContainer.vue?vue&type=script&lang=ts&"
export * from "./DeviceBoxContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ab833a",
  null
  
)

export default component.exports